import { render } from "./404.vue?vue&type=template&id=30c1e3d6&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=30c1e3d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30c1e3d6"

export default script